import { BuscaAtivaVacinacaoInput } from 'graphql/types.generated'
import { isNumber } from 'lodash'

import { BuscaAtivaVacinacaoFormModel } from './model-buscaAtivaVacinacao'

export default (model: BuscaAtivaVacinacaoFormModel): BuscaAtivaVacinacaoInput => ({
  grupoAlvo: model.grupoAlvo?.enum,
  faixaEtaria: {
    idadeMinima: model.faixaEtaria?.firstValue,
    idadeMaxima: model.faixaEtaria?.secondValue,
    tipoFaixaEtaria:
      isNumber(model.faixaEtaria?.firstValue) || isNumber(model.faixaEtaria?.secondValue)
        ? model.faixaEtaria?.tipoFaixaEtaria
        : null,
  },
  status: model.status?.enum,
  equipeVinculadaIne: model.equipe?.ine,
  microareas: model.microareas,
  filtrosAvancados: {
    imunobiologicoIds: model.filtrosAvancados?.imunobiologicos?.map((imuno) => imuno.id),
    doseIds: model.filtrosAvancados?.doses?.map((dose) => dose.id),
    grupoAtendimentoIds: model.filtrosAvancados?.gruposAtendimento?.map((grupo) => grupo.id),
    bairro: model.filtrosAvancados?.bairro,
    nomeTipoLogradouro: model.filtrosAvancados?.tipoLogradouro?.nome,
    logradouro: model.filtrosAvancados?.logradouro,
  },
  tipoVisualizacao: model.tipoVisualizacao,
  pageParams: {
    sort: ['cidadao', 'idade'],
    size: 2000, // TODO (Royal Flush): Utilizar o usePagedTableProps quando a estrutura de vacinação for finalizada (#22307). Baseado no módulo de exames.
    ...model.pageParams,
  },
})
